var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2798 7C17.2798 8.32608 16.7519 9.59785 15.8124 10.5355C14.8729 11.4732 13.5986 12 12.2699 12C10.9412 12 9.6669 11.4732 8.72737 10.5355C7.78783 9.59785 7.26001 8.32608 7.26001 7C7.26001 5.67392 7.78783 4.40215 8.72737 3.46447C9.6669 2.52678 10.9412 2 12.2699 2C13.5986 2 14.8729 2.52678 15.8124 3.46447C16.7519 4.40215 17.2798 5.67392 17.2798 7Z",
    fill: "#6EA84D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2699 11C10.9903 11 9.77063 11.269 8.66895 11.75C5.77765 13.012 3.68102 15.747 3.3147 19C3.3147 20.105 4.14924 21 5.25602 21H19.2837C20.3909 21 21.2255 20.105 21.2255 19C20.8588 15.747 18.7617 13.012 15.871 11.75C14.7688 11.269 13.5494 11 12.2699 11Z",
    fill: "#6EA84D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUser);
export default __webpack_public_path__ + "static/media/total_user.3f1550949be1f7e10ee05bb147d41613.svg";
export { ForwardRef as ReactComponent };